import { DialogType } from '@/enums/dialogType'
import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        category: {},
        lstCategory: [],
        isUpdate: false,
        shouldReload: false,
        search: "",
        itemsPerPage: 25,
        hasNext: false,
        page: 1,
        totalItems: 0,
        headers: [
            { title: 'Categoria', key: 'categoryName', align: 'center' }
        ],
    },
    getters: {
        getCategory(state) {
            let category = { ...state.category }
            return category
        }
    },
    mutations: {
        setCategory(state, category) {
            state.category = category
        },
        setLstCategory(state, lstCategory) {
            state.lstCategory = lstCategory
        },
        appendLstCategory(state, items) {
            state.lstCategory = [...state.lstCategory, ...items]
        },
        clearLstCategory(state) {
            state.lstCategory = []
        },
        setPage(state, page) {
            state.page = page
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setTotalItems(state, total) {
            state.totalItems = total
        },
        setShouldReload(state, reload) {
            state.shouldReload = reload
        },
        initForm(state) {
            state.isUpdate = false
            state.category = {}
            state.search = ''
        },
        setUpdating(state) {
            state.isUpdate = true
        }
    },
    actions: {
        async save({ state, dispatch }) {
            if (state.isUpdate) {
                return await dispatch('update')
            }
            else
                return await dispatch('insert')
        },

        async insert({ getters, dispatch }) {
            await api.post(
                '/Category/Insert',
                getters.getCategory
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Categoria salva'
            }, { root: true })

            return true
        },

        async update({ getters, dispatch }) {
            await api.put(
                '/Category/Update',
                getters.getCategory
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Categoria atualizada'
            }, { root: true })

            return true
        },

        async search({ state, commit }, { search, limit = 25, page = 1, reset}) {
            let searchParam = search || state.search
            const response = await api.get(
                `/Category/Search?search=${searchParam}&limit=${limit}&page=${page}`
            )

            if (reset) {
                commit("setLstCategory", response.data.items)
            } else {
                commit("appendLstCategory", response.data.items)
            }

            commit('setHasNext', response.data.hasNext)
            commit('setTotalItems', response.data.totalCount)
            commit('setPage', page)

            return true
        },

        async find({commit}, categoryId) {
            const response = await api.get(
                `/Category/Find/${categoryId}`,
            )
            commit('setCategory', response.data)
            commit('setUpdating')

            return true
        },

        async findAll({ commit }) {
            const response = await api.get(
                `/Category/FindAll/`,
            )
            commit('setLstCategory', response.data)
            
            return true
        },

        async delete({ getters, dispatch }) {
            await api.delete(
                `/Category/Delete/${getters.getCategory.categoryId}`,
            )
            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Registro deletado com sucesso!'
            }, { root: true })

            return true
        }
    }
}